export default [
    {
      reducerKey: 'user/accounts',
      sagaKey: 'userAccountsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Accounts/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Accounts/store/saga'),
    },
    {
      reducerKey: 'user/profile',
      sagaKey: 'userProfileSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Profile/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Profile/store/saga'),
    },
    {
      reducerKey: 'user/2fa',
      sagaKey: 'user2faSaga',
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/2fa/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/2fa/store/saga'),
    },
    {
      sagaKey: 'userPasswordSaga',
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Security/Password/store/saga'),
    },
    {
      reducerKey: 'user/api-access',
      sagaKey: 'userApiAccessSaga',
      routeKeys: ['user/settings', 'user/settings/api-apps', 'user/settings/api-apps/new', 'user/settings/api-apps/edit'],
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Settings/ApiAccess/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/User/Settings/ApiAccess/store/saga'),
    },
    {
      reducerKey: 'countries',
      sagaKey: 'countriesSaga',
      routeKeys: ['user/settings'],
      importReducer: () => import(/* webpackChunkName: "domain-user" */ 'modules/Countries/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-user" */ 'modules/Countries/store/saga'),
    },
]
